import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { HcToastrService } from '@manager-app/service/toastr.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContractService } from '@manager-app/storage/service/contract.service';
import { ContractModel, extractNumber, HxUiLabelPipe } from 'hx-services';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe, JsonPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-contract-view.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './contract-view.component.html',
    styleUrls: ['./contract-view.component.css'],
    imports: [NgIf, RouterLink, NgClass, NgFor, JsonPipe, DatePipe, TranslocoPipe, HxUiLabelPipe]
})
export class ContractViewComponent implements OnInit, OnDestroy {
  @ViewChild('templateRef') public templateRef: TemplateRef<any>;
  contract: ContractModel;
  id: number;
  isLoading = {
    contract: false,
  };
  image = {
    name: null,
    path: null,
    mimeType: null
  };
  baseLink = `/api/vn/files/download/`;
  private sub: Subscription;

  constructor(
    private aRoute: ActivatedRoute,
    private contractService: ContractService,
    private router: Router,
    private toastr: HcToastrService,
    private modal: NgbModal,
    private domSanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
    this.sub = this.aRoute.paramMap.subscribe(paramMap => {
      this.id = extractNumber('id', paramMap);
      this.loadData();
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  goBack(): void {
    if (window.history.length > 0) {
      window.history.back();
    } else {
      this.router.navigate(['../'], {relativeTo: this.aRoute});
    }
  }

  showImage(file): void {
    this.image.name = file.fileName;
    this.image.path = this.baseLink + file.guid;
    this.image.mimeType = file.mimeType;
    if (file.mimeType === 'application/pdf') {
      this.image.path = this.domSanitizer.bypassSecurityTrustResourceUrl(this.image.path);
    }

    this.modal.open(this.templateRef, {size: 'lg'}).result
      .then(() => this.resetImage())
      .catch(() => this.resetImage());
  }

  closeModal(modal: any) {
    modal.dismiss();
  }

  private async loadData() {
    if (this.id) {
      this.contract = undefined;
      this.isLoading.contract = true;
      try {
        this.contract = await this.contractService.getContract(this.id);
      } finally {
        this.isLoading.contract = false;
      }
    }
  }

  private resetImage() {
    this.image.name = null;
    this.image.path = '';
  }
}
